import React, { useState } from 'react';
import './about.css';

function About() {
    const [playVideo, setPlayVideo] = useState(false);

    return (
        <div className="about-container">
            <div className="about-video">
                {!playVideo ? (
                    <div className="about-thumbnail-wrapper" onClick={() => setPlayVideo(true)}>
                        <img
                            src="https://i.ytimg.com/vi/HtkpJCMDEbM/maxresdefault.jpg"
                            alt="C4GT Dedicated Mentoring Program 2025"
                            className="about-thumbnail"
                        />
                        <div className="play-icon">
                            <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
                                <circle cx="40" cy="40" r="40" fill="rgba(0,0,0,0.5)" />
                                <polygon points="32,25 32,55 58,40" fill="#fff" />
                            </svg>
                        </div>
                    </div>
                ) : (
                    <iframe
                        className="about-drive-video"
                        width="100%"
                        height="315"
                        src="https://drive.google.com/file/d/1aFP_I7MFAv4qFt9SUCy0Xlj13lHm_t_t/preview"
                        title="C4GT Dedicated Mentoring Program 2025"
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                    ></iframe>
                )}
            </div>
            <div className="about-content">
                <h2>Dedicated Mentoring Program</h2>
                <p>
                    Since 2022, Code for GovTech (C4GT)'s Dedicated Mentoring Program (DMP) has empowered students and working professionals to contribute to critical open-source tech projects that have population-scale impact. Over three months, contributors work with Digital Public Good (DPG) and Tech for Good organizations, receiving 1:1 mentorship from industry experts from these organizations or from "Angel Mentors" who are volunteers from the C4GT community.
                </p>
                <p>
                    DMP offers a unique chance to dive into real-world projects, gain insights from ecosystem leaders, and grow through peer learning, making it a transformative journey for aspiring tech innovators.
                </p>
            </div>
        </div>
    );
}

export default About;